export default {
  fa: {
    up: 'بالاتر',
    down: 'پایین‌تر',
    ruleTitle: 'پزشکان این قانون',
    ruleIntro: 'یک تا سه پزشک انتخاب کنید تا در مطلب‌های مطابق این قانون نمایش داده شوند.',
    mode: 'نمایش پزشکان',
    auto: 'پیشنهاد خودکار',
    manual: 'انتخاب برای این مطلب',
    disabled: 'نمایش نده',
    autoHint: 'پزشکان بر اساس تنظیمات کلی و موضوع مطلب انتخاب می‌شوند. اگر مورد مرتبطی پیدا نشود، پزشکان پیش‌فرض یا پزشکان انتخاب‌شده برای مطالب دیگر نمایش داده می‌شوند.',
    globalSettings: 'تنظیمات کلی پزشکان مطالب',
    loading: 'در حال دریافت پروفایل…',
    eyebrow: 'همراه شما در قدم بعدی',
    title: 'با متخصصان این موضوع آشنا شوید',
    intro: 'پروفایل و راه‌های نوبت‌گیری را ببینید و با آگاهی انتخاب کنید.',
    profile: 'مشاهده پروفایل',
    booking: 'پروفایل و نوبت‌گیری',
    editorTitle: 'پزشکان این مطلب',
    editorIntro: 'پیشنهادها بر اساس برچسب‌های مشترک هستند. فقط پروفایل‌های مرتبط و تأییدشده را انتخاب کنید؛ حداکثر سه نفر.',
    enable: 'نمایش باکس در این زبان',
    middle: 'میان متن، بعد از یک پاراگراف کامل',
    end: 'انتهای محتوا',
    placement: 'محل نمایش',
    suggest: 'پیشنهاد بر اساس موضوع',
    search: 'جستجوی نام یا تخصص',
    find: 'جستجو',
    empty: 'پیشنهادی پیدا نشد. برچسب‌های موضوعی مطلب و پروفایل متخصص را بررسی کنید یا دستی جستجو کنید.',
    failed: 'دریافت پروفایل‌ها انجام نشد؛ دوباره تلاش کنید.',
    reason: 'برچسب مشترک:',
    selected: 'انتخاب‌شده',
    remove: 'حذف از انتخاب',
    unavailable: 'این پروفایل در این زبان در دسترس نیست. قبل از فعال‌کردن باکس، انتخاب را اصلاح کنید.',
    max: 'حداکثر سه متخصص را انتخاب کنید.',
    locale: 'انتخاب‌ها فقط برای زبان محتوای فعلی ذخیره می‌شوند.',
    none: 'هنوز متخصصی انتخاب نشده است.',
  },
  en: {
    up: 'Move up',
    down: 'Move down',
    ruleTitle: 'Doctors for this rule',
    ruleIntro: 'Choose one to three doctors to show on posts matching this rule.',
    mode: 'Doctor display',
    auto: 'Automatic suggestions',
    manual: 'Choose for this content',
    disabled: 'Do not show',
    autoHint: 'Doctors follow global rules and shared topic tags. When no related profile is found, default doctors or doctors selected for other content are shown.',
    globalSettings: 'Content doctor settings',
    loading: 'Loading profile…',
    eyebrow: 'Your next step',
    title: 'Meet specialists in this field',
    intro: 'Explore their profiles and appointment options to make an informed choice.',
    profile: 'View profile',
    booking: 'Profile & appointments',
    editorTitle: 'Doctors for this content',
    editorIntro: 'Suggestions use shared topic tags. Select relevant, approved profiles only; up to three.',
    enable: 'Show this block in this language',
    middle: 'Within the text, after a complete paragraph',
    end: 'After the content',
    placement: 'Placement',
    suggest: 'Suggest by topic',
    search: 'Search name or specialty',
    find: 'Search',
    empty: 'No suggestions found. Review shared topic tags or search manually.',
    failed: 'Profiles could not be loaded. Please try again.',
    reason: 'Shared topic:',
    selected: 'Selected',
    remove: 'Remove selection',
    unavailable: 'This profile is unavailable in this language. Review your selection before enabling the block.',
    max: 'Select up to three specialists.',
    locale: 'Selections are saved for the current content language only.',
    none: 'No specialists selected yet.',
  },
  ar: {
    up: 'نقل لأعلى',
    down: 'نقل لأسفل',
    ruleTitle: 'أطباء هذه القاعدة',
    ruleIntro: 'اختاروا طبيبًا واحدًا إلى ثلاثة أطباء لعرضهم مع المحتوى المطابق لهذه القاعدة.',
    mode: 'عرض الأطباء',
    auto: 'اقتراح تلقائي',
    manual: 'اختيار لهذا المحتوى',
    disabled: 'عدم العرض',
    autoHint: 'يتم اختيار الأطباء حسب الإعدادات العامة ووسوم الموضوع المشتركة. إذا لم نجد طبيبًا مرتبطًا بالموضوع، يظهر الأطباء الافتراضيون أو الأطباء المختارون لمحتوى آخر.',
    globalSettings: 'إعدادات أطباء المحتوى',
    loading: 'جارٍ تحميل الملف…',
    eyebrow: 'معكم في الخطوة التالية',
    title: 'تعرّفوا على المتخصصين في هذا المجال',
    intro: 'اطّلعوا على ملفاتهم وخيارات حجز الموعد لاختيار ما يناسبكم.',
    profile: 'عرض الملف',
    booking: 'الملف وحجز الموعد',
    editorTitle: 'أطباء هذا المحتوى',
    editorIntro: 'تعتمد الاقتراحات على وسوم الموضوع المشتركة. اختاروا ملفات مناسبة ومعتمدة فقط؛ ثلاثة كحد أقصى.',
    enable: 'عرض القسم بهذه اللغة',
    middle: 'داخل النص بعد فقرة كاملة',
    end: 'بعد المحتوى',
    placement: 'موضع العرض',
    suggest: 'اقتراح حسب الموضوع',
    search: 'البحث بالاسم أو التخصص',
    find: 'بحث',
    empty: 'لم نجد اقتراحات. راجعوا وسوم الموضوع المشتركة أو ابحثوا يدويًا.',
    failed: 'تعذّر تحميل الملفات. يرجى المحاولة مجددًا.',
    reason: 'موضوع مشترك:',
    selected: 'تم الاختيار',
    remove: 'إزالة الاختيار',
    unavailable: 'هذا الملف غير متاح بهذه اللغة. راجعوا الاختيار قبل تفعيل القسم.',
    max: 'يمكن اختيار ثلاثة متخصصين كحد أقصى.',
    locale: 'تُحفظ الاختيارات للغة المحتوى الحالية فقط.',
    none: 'لم يتم اختيار متخصصين بعد.',
  },
}
